// The Intro — homepage first-load mark. Black screen holds the eye mark
// alone, static (no eyelid-blink animation, no wordmark), for 1s, then a
// radial mask wipes the darkness away from the center outward, revealing
// the hero underneath. Plays once per session; skippable by any input;
// respects reduced-motion.
//
// Definitive Redesign, Part 5 fix (still applies): on a real device the
// eye image can still be loading when this script runs (it's competing
// with fonts, the hero video, CSS, everything else for the first paint).
// The exit clock must never start until the eye is CONFIRMED painted, or
// on a slow load the whole sequence could run out before the image ever
// painted, and the first thing a real visitor saw was an already-
// finished, about-to-vanish mark.
(function () {
  const overlay = document.getElementById("blink-overlay");
  if (!overlay) return; // not on this page
  const eyeImg = overlay.querySelector(".blink-eye");

  const SESSION_KEY = "sixthsense-blink-seen";
  // ?intro=1 force-replays the intro regardless of the session flag — the
  // only way to see it again without a fresh session/incognito window.
  const forceReplay = new URLSearchParams(location.search).get("intro") === "1";
  const seenThisSession = !forceReplay && sessionStorage.getItem(SESSION_KEY);
  sessionStorage.setItem(SESSION_KEY, "1");

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // reveal.js skips the hero's own auto-reveal when a blink overlay is present
  // (see reveal.js) so the hero can stagger in right as the mask opens,
  // instead of finishing its reveal silently underneath an opaque overlay.
  function revealHero() {
    const hero = document.getElementById("hero");
    if (hero) hero.classList.add("revealed");
  }

  let revealing = false;
  let done = false;
  function finish() {
    if (done) return;
    done = true;
    overlay.classList.add("hidden");
  }

  // Grows --reveal-r (a pixel radius, not a percentage — avoids CSS's
  // ambiguous percentage-resolution rules for radial-gradient stops) from 0
  // to past the viewport's half-diagonal, so the transparent hole in the
  // mask always ends up covering the full screen regardless of aspect ratio.
  // Exponential ease-out (per the brief's "ease-out-expo") so the wipe
  // opens fast at first and settles gently, reading as deliberate rather
  // than mechanical.
  function revealFromCenter(duration) {
    if (revealing || done) return;
    revealing = true;
    revealHero();
    const maxR = Math.hypot(window.innerWidth, window.innerHeight) / 2 + 60;
    const start = performance.now();
    function step(now) {
      const t = Math.min((now - start) / duration, 1);
      const eased = t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
      overlay.style.setProperty("--reveal-r", (eased * maxR) + "px");
      if (t < 1) requestAnimationFrame(step);
      else finish();
    }
    requestAnimationFrame(step);
  }

  // Waits for the eye image to be confirmed decoded and painted before
  // calling back — never assumes it's already there. A 3s safety timeout
  // covers a stalled/failed load so the intro can never hang on a blank
  // overlay; it just proceeds and holds the (possibly still-loading) eye
  // for the guaranteed minimum instead.
  function whenEyePainted(cb) {
    if (!eyeImg) { cb(); return; }
    if (eyeImg.complete && eyeImg.naturalWidth > 0) { cb(); return; }
    let called = false;
    const done = () => { if (called) return; called = true; cb(); };
    eyeImg.addEventListener("load", done, { once: true });
    eyeImg.addEventListener("error", done, { once: true });
    setTimeout(done, 3000);
  }

  // Eye holds static on screen for a full second, then dissolves into the
  // hero. No blink animation, no wordmark — just the eye, then gone.
  const HOLD_MS = 1000;
  const DISSOLVE_MS = 750;

  if (seenThisSession) {
    // Already seen this session — skip straight to a quick wipe.
    revealFromCenter(400);
  } else if (reducedMotion) {
    // No hold, no wipe — straight to the hero.
    finish();
    revealHero();
  } else {
    whenEyePainted(() => {
      if (revealing || done) return; // a skip already fired while we waited
      // The exit clock starts here, now that the eye is confirmed on
      // screen — not at script execution.
      setTimeout(() => revealFromCenter(DISSOLVE_MS), HOLD_MS);
    });
  }

  // Never trap the user: any input fast-forwards straight to the reveal.
  ["click", "keydown", "wheel", "touchstart"].forEach((evt) => {
    window.addEventListener(evt, () => revealFromCenter(300), { once: true, passive: true });
  });
})();
